import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import AddMessageModal from "../Modals/AddMessageModal";
import dayjs from "dayjs";


import { Button } from "@mui/material";

export default function MessagesTable(  {setErrOpen, setErrMessage}) {
  const [messages, setMessages] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [refresh, setRefresh] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);

  const [open, setOpen] = React.useState(false);


  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setInitialVals({
      message: "",
      start: "",
      end: "",
      type: ""
    })
  };

  const [initialVals, setInitialVals] = React.useState({
    message: "",
    start: "",
    end: "",
    type: ""
  });


//setMessages with a filtered array before doing axios.delete, then refresh?

  function deleteMessage(id) {
    setMessages(messages.filter((message)=>{
      return message.id !== id
    }))
    setRefresh(refresh + 1)
    if (id) {
      axios
        .delete(`/delete_message/${id}`)
        .then((res)=>{
          setRefresh(refresh + 1)
        })
        .catch((err) => {
          setErrMessage(err.response.data)
          setErrOpen(true)
        });
    }
  }

  function copyMessage(message, start, end, type) {
    let newState = initialVals
    newState.message = message
    newState.start = start
    newState.end = end
    newState.type = type
    setInitialVals(newState)
    setOpen(true)
    
  }

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
    },
    {
      field: "message",
      headerName: "message",
      minWidth: 400,
      flex: 3,
    },
    {
      field: "type",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        let text = "";
        if (params.row.type == 0) text = "Info";
        else if (params.row.type == 1) text = "Success";
        else if (params.row.type == 2) text = "Warning";
        else if (params.row.type == 3) text = "Danger";
        else text = "none";
        return (
            <p>{text}</p>
        );
      },
      headerName: "type",
      
    },
    {
      field: "start",
      headerName: "start",
      minWidth: 100,
      flex: 2,
    },
    {
      field: "end",
      headerName: "end",
      minWidth: 100,
      flex: 2,
    },
    {
      field: "status",
      renderCell: (params) => {
        let text = "Active";
        if (dayjs(params.row.end) < dayjs()) text = "Expired";
        else if (dayjs(params.row.start) > dayjs()) text = "Pending";
        return (
            <p>{text}</p>
        );
      },
      headerName: "status",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "action",
      disableColumnMenu: true,
      width:200,
      sortable: false,
      renderCell: (params) => {
        const onClickDelete = (e) => {
          e.stopPropagation();
          deleteMessage(params.row.id);
        };
        const onClickCopy = (e) => {
          e.stopPropagation();
          copyMessage(params.row.message, params.row.start, params.row.end, ""+params.row.type);
        };

        return (
          <>
            <Button size="small" variant="contained" onClick={onClickCopy}>
              Copy
            </Button>
            <Button size="small" variant="contained" onClick={onClickDelete}>
              Delete
            </Button>
          </>
        );
      },
    },
  ];

  React.useEffect(() => {
    axios
      .get(`/get_messages`)
      .then((res) => {
        setMessages(res.data.messages);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, [refresh]);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            
            alignItems: "flex-end",
          }}
        >
          
          <Box sx={{ height: 660, width: "100%" }}>
            <DataGrid
              loading={isLoading}
              rows={messages}
              columns={columns}
              pageSize={10}
  
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
          <AddMessageModal
            messages={messages}
            setMessages={setMessages}
            refresh={refresh}
            setRefresh={setRefresh}
            setErr={setErr}
            open={open}
            setOpen={setOpen}
            setErrOpen={setErrOpen} 
            setErrMessage={setErrMessage}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            initialVals={initialVals}
          />
        </div>
      )}
    </React.Fragment>
  );
}
